import { render, staticRenderFns } from "./SingleUserPlanDescription.vue?vue&type=template&id=6ec6e47c&scoped=true&"
import script from "./SingleUserPlanDescription.vue?vue&type=script&lang=js&"
export * from "./SingleUserPlanDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec6e47c",
  null
  
)

export default component.exports